// El body de un `DomainError` no lleva el status: sin él `shouldRetryQuery` no
// distingue un 4xx. Se usa `http_status` y no `statusCode` porque `isServerError`
// mandaría a Sentry los 503 de `query_timeout`.
export const withHttpStatus = (
  error: unknown,
  response: Response | undefined,
): unknown => {
  if (!response || response.ok) {
    return error;
  }
  return typeof error === "object" && error !== null
    ? { ...error, http_status: response.status }
    : { body: error, http_status: response.status };
};
